// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

const WORKSHEET_LINEAR_LAYOUT_VIEW_ORDER_TO_PERSISTENCE_KEY = {
  AUTO: 'auto',
  MANUAL: 'manual'
} as const;

/** @see net/disy/cadenza/workbook/model/WorksheetLinearLayoutViewOrder.java */
export type WorksheetLinearLayoutViewOrder = keyof typeof WORKSHEET_LINEAR_LAYOUT_VIEW_ORDER_TO_PERSISTENCE_KEY;

export const WorksheetLinearLayoutViewOrder = {
  values: Object.keys(WORKSHEET_LINEAR_LAYOUT_VIEW_ORDER_TO_PERSISTENCE_KEY) as readonly WorksheetLinearLayoutViewOrder[],
  toPersistenceKey: (value: WorksheetLinearLayoutViewOrder) => WORKSHEET_LINEAR_LAYOUT_VIEW_ORDER_TO_PERSISTENCE_KEY[value],
  fromPersistenceKey: (persistenceKey: string) => {
    const value = WorksheetLinearLayoutViewOrder.values.find(key => WORKSHEET_LINEAR_LAYOUT_VIEW_ORDER_TO_PERSISTENCE_KEY[key] === persistenceKey);
    if (!value) { throw new Error(`No WorksheetLinearLayoutViewOrder for key: ${persistenceKey}`); }
    return value;
  },
} as const;

// </GENERATED-CODE>
